/* Melanie Newman — cart bundle nudge engine. UK (Dawn) build.
   Families may be keyed by product "ids" (AU) or portable "handles" (UK/CA).
   UpCart branches below no-op harmlessly where UpCart is absent (UK/CA).
   Per-family counters. Mirrors SELLY offer maths exactly (verified 4 Aug 2026).
   Rules encoded:
     - each family has its own independent counter; families never combine
     - within a bundle, positions are filled DEAREST FIRST (position 0 = dearest)
     - SELLY consumes items: largest matching bundle first, then leftovers
     - subscription lines are skipped (retail sub-suppression)
     - UK (SUB_NO_BUNDLE): subscription lines COUNT toward the tier but RECEIVE no bundle
       discount (SELLY default for accounts > 20655; checkout-verified 22 Oct 2026).
       Flip SUB_NO_BUNDLE to false once SELLY support enables sub-line discounts on UK.
     - wholesale customers see ONLY families flagged wholesale:true (cutter heads);
       everything else is retail-only, because SELLY trade pricing replaces it
*/
(function () {
  'use strict';
  var cfgEl = document.getElementById('mn-bundle-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!CFG) return;
  var WS = !!(CFG.wholesale || CFG.previewWholesale);
  var SUB_NO_BUNDLE = false;  // UK: SELLY support enabled sub-line discounts 23 Oct 2026 (nfec.ysSub=1); sub lines now get the bundle saving.

  var FAMS = (CFG.families || []).filter(function (f) {
    if (!f.enabled) return false;
    if (!(f.ids && f.ids.length) && !(f.handles && f.handles.length)) return false;
    return WS ? !!f.wholesale : true;         // wholesale: cutter heads only
  });
  if (!FAMS.length) return;

  // fast lookup: productId -> family
  var INDEX = {};
  FAMS.forEach(function (f) {
    f._bundles = (f.bundles || []).slice().sort(function (a, b) { return b.n - a.n; });
    f._min = f.perItem && f.perItem.length ? f.perItem[0].minQty
      : (f._bundles.length ? f._bundles[f._bundles.length - 1].n : 99);
    (f.ids || []).forEach(function (id) { INDEX[String(id)] = f; });
    (f.handles || []).forEach(function (h) { INDEX[String(h)] = f; });
  });

  var money = function (c) {
    return (CFG.symbol || '$') + (Math.floor(c + 0.0001) / 100).toFixed(2);  // never quote a cent more than the cart gives
  };

  /* ---- core maths: total discount (cents) for a set of unit prices ---- */
  // entries: { p: unit price (cents), sub: true if a selling-plan line }
  function discountFor(fam, entries) {
    var rem = entries.slice().sort(function (a, b) { return b.p - a.p; });
    var total = 0, i;
    var eligible = function (e) { return !(SUB_NO_BUNDLE && e.sub); };
    if (fam.perItem && fam.perItem.length) {   // quantity breaks: flat $ off EVERY item, "N or more"
      var amt = 0;
      for (i = 0; i < fam.perItem.length; i++) if (rem.length >= fam.perItem[i].minQty) amt = fam.perItem[i].amt;
      if (!amt) return 0;
      for (i = 0; i < rem.length; i++) if (eligible(rem[i])) total += Math.min(amt, rem[i].p);
      return total;
    }
    while (rem.length >= fam._min) {
      var chosen = null;
      for (var i = 0; i < fam._bundles.length; i++) {
        if (fam._bundles[i].n <= rem.length) { chosen = fam._bundles[i]; break; }
      }
      if (!chosen) break;
      var chunk = rem.splice(0, chosen.n);
      for (var j = 0; j < chunk.length; j++) {
        if (!eligible(chunk[j])) continue;          // sub line fills the slot but earns nothing
        if (chosen.amounts) {                       // flat dollars off each (cents)
          total += Math.min(chosen.amounts[j] || 0, chunk[j].p);
        } else {
          total += chunk[j].p * (chosen.rates[j] || 0) / 100;
        }
      }
    }
    return total;
  }

  /* ---- what does adding k more of this family earn? ---- */
  function lookahead(fam, entries, base) {
    var addPrice = entries.length ? Math.min.apply(null, entries.map(function (e) { return e.o || e.p; })) : (fam.typicalPrice || 0);
    if (!addPrice) return null;
    var probe = entries.slice();
    for (var k = 1; k <= 4; k++) {
      probe.push({ p: addPrice, sub: false });     // the "one more" is assumed one-time
      var gain = discountFor(fam, probe) - base;
      if (gain > 0.5) return { k: k, gain: gain };
    }
    return null;
  }

  /* ---- build one line of copy per family ---- */
  function messages(cart) {
    var byFam = {}, hasSub = false;
    (cart.items || []).forEach(function (li) {
      var fam = INDEX[String(li.product_id)] || INDEX[String(li.handle || '')];
      if (!fam) return;
      // 5L is the salon trade size: outside the retail ladder (SELLY excludes these variants too).
      if (fam.excludeVariantTitle && String(li.variant_title || '').toUpperCase().indexOf(String(fam.excludeVariantTitle).toUpperCase()) >= 0) return;
      var arr = byFam[fam.key] || (byFam[fam.key] = []);
      // Selling-plan lines count toward the tier. Whether they also receive the discount
      // depends on SUB_NO_BUNDLE (UK: no, checkout-verified 22 Oct 2026).
      var sp = li.selling_plan_allocation;
      if (sp) hasSub = true;
      var unit = (sp && sp.price != null) ? sp.price
        : (li.original_price != null ? li.original_price : li.price);
      for (var q = 0; q < li.quantity; q++) arr.push({ p: unit, o: (li.original_price != null ? li.original_price : li.price), sub: !!sp });
    });

    var out = [];
    FAMS.forEach(function (fam) {
      var prices = byFam[fam.key];
      if (!prices || !prices.length) return;
      var saving = discountFor(fam, prices);
      var nxt = lookahead(fam, prices, saving);
      var line = { key: fam.key, label: fam.label, saving: saving, state: '', text: '' };

      if (saving > 0.5 && !nxt) {
        line.state = 'peak';
        line.text = 'Nice work \u2014 you\u2019re saving <b>' + money(saving) + '</b> on ' + fam.label + '.';
      } else if (saving > 0.5 && nxt) {
        line.state = 'progress';
        line.text = 'You\u2019re saving <b>' + money(saving) + '</b> on ' + fam.label + '. Add ' +
          (nxt.k === 1 ? 'one more ' + fam.noun : nxt.k + ' more ' + fam.nounPlural) +
          ' to save <b>' + money(nxt.gain) + '</b> more.';
      } else if (nxt) {
        line.state = 'start';
        line.text = 'Add ' + (nxt.k === 1 ? 'one more ' + fam.noun : nxt.k + ' more ' + fam.nounPlural) +
          ' and save <b>' + money(nxt.gain) + '</b>.' + (fam.hint ? ' <span class="mn-nudge__hint">' + fam.hint + '</span>' : '');
      } else { return; }
      out.push(line);
    });
    if (hasSub && out.length) {
      out.push({ key: 'subnote', state: 'note', saving: 0,
        text: SUB_NO_BUNDLE
          ? 'Subscription items are already at your Subscribe &amp; Save price, so the bundle saving applies to one-time items only \u2014 pause or cancel anytime.'
          : 'Your bundle saving applies to this order. Subscription items then renew at your usual Subscribe &amp; Save price \u2014 pause or cancel anytime.' });
    }
    return out;
  }

  /* ---- render ---- */
  // Every cart surface gets its own mount: the Fluorescent fly-out, a generic
  // drawer, and the full cart page. All are painted, whichever is on screen.
  var HOSTS = [
    '.quick-cart__footer',
    'cart-drawer .drawer__footer, cart-drawer form, #CartDrawer form, .cart-drawer__footer',
    '.cart__footer, form[action*="/cart"] .cart__blocks, main form[action*="/cart"]'
  ];

  // UpCart renders inside a shadow root, so it needs its own mount and its own
  // copy of the styles (shadow DOM does not inherit the page stylesheet).
  var SHADOW_CSS = '.mn-nudge{margin:10px 0 4px;display:flex;flex-direction:column;gap:8px;text-align:left}' +
    '.mn-nudge__row{display:flex;gap:9px;align-items:flex-start;margin:0;padding:11px 13px;' +
    'border:1px solid rgba(200,151,90,.34);border-radius:10px;background:rgba(200,151,90,.07);' +
    'font-size:13px;line-height:1.42;color:#171717}' +
    '.mn-nudge__row b{color:#8B6914;font-weight:650;white-space:nowrap}' +
    '.mn-nudge__row--peak{border-color:rgba(253,197,221,.9);background:rgba(253,197,221,.22)}' +
    '.mn-nudge__row--peak b{color:#171717}' +
    '.mn-nudge__icon{flex:0 0 16px;width:16px;height:16px;margin-top:1px;border-radius:50%;' +
    'background:#C8975A;position:relative}' +
    '.mn-nudge__icon::after{content:"+";position:absolute;inset:0;color:#fff;font-size:12px;' +
    'line-height:16px;text-align:center;font-weight:700}' +
    '.mn-nudge__row--peak .mn-nudge__icon{background:#171717}' +
    '.mn-nudge__row--peak .mn-nudge__icon::after{content:"\\2713";font-size:10px}' +
    '.mn-nudge__hint{display:block;margin-top:2px;font-size:11.5px;opacity:.72}' +
    '.mn-nudge__row--note{color:#6b6b6b;font-size:12px;line-height:1.45}' +
    '.mn-nudge__row--note .mn-nudge__icon{opacity:.45}';

  function upcartRoot() {
    var r = window.upcartDocumentOrShadowRoot;
    return (r && typeof r.querySelector === 'function') ? r : null;
  }

  function upcartMount() {
    var root = upcartRoot();
    if (!root) return null;
    var products = root.querySelector('.upcart-products-section');
    var body = root.querySelector('.upcart-cart-body');
    if (!products && !body) return null;
    if (!root.querySelector('#mn-nudge-style')) {
      var st = document.createElement('style');
      st.id = 'mn-nudge-style'; st.textContent = SHADOW_CSS;
      root.appendChild(st);
    }
    var el = root.querySelector('[data-mn-cart-nudge]');
    if (el && el.parentNode) return el;
    el = document.createElement('div');
    el.setAttribute('data-mn-cart-nudge', 'upcart');
    el.style.padding = '0 16px';
    if (products && products.parentNode) products.parentNode.insertBefore(el, products.nextSibling);
    else body.appendChild(el);
    return el;
  }

  function mounts() {
    var out = [].slice.call(document.querySelectorAll('[data-mn-cart-nudge]'));
    var uc = upcartMount();
    if (uc) out.push(uc);
    HOSTS.forEach(function (sel) {
      var host = document.querySelector(sel);
      if (!host) return;
      for (var i = 0; i < out.length; i++) if (host.contains(out[i])) return;
      var d = document.createElement('div');
      d.setAttribute('data-mn-cart-nudge', 'auto');
      host.insertBefore(d, host.firstChild);
      out.push(d);
    });
    return out;
  }

  function paint(lines) {
    var els = mounts();
    if (!els.length) return;
    var html = '';
    if (lines.length) {
      html = '<div class="mn-nudge">' + lines.map(function (l) {
        return '<p class="mn-nudge__row mn-nudge__row--' + l.state + '">' +
          '<span class="mn-nudge__icon" aria-hidden="true"></span><span>' + l.text + '</span></p>';
      }).join('') + '</div>';
    }
    els.forEach(function (el) { if (el.innerHTML !== html) el.innerHTML = html; });
  }

  var lastLines = null;
  var last = 0;
  function refresh() {
    var now = Date.now();
    if (now - last < 250) return;
    last = now;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { lastLines = messages(c); paint(lastLines); })
      .catch(function () {});
  }

  // hook every cart mutation the theme or an app can make
  document.addEventListener('cart:refresh', refresh);
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:change', refresh);
  document.addEventListener('flu:cart:updated', refresh);      // Fluorescent theme bus
  document.addEventListener('flu:cart:item-added', refresh);
  document.addEventListener('flu:quick-cart:open', function () { last = 0; refresh(); });

  // UpCart's own event API, plus a watcher so a React re-render cannot drop the nudge
  ['upcartSubscribeCartLoaded', 'upcartSubscribeCartUpdated', 'upcartSubscribeCartOpened',
   'upcartSubscribeAddedToCart', 'upcartSubscribeItemRemoved'].forEach(function (fn) {
    try { if (typeof window[fn] === 'function') window[fn](function () { last = 0; refresh(); }); } catch (e) {}
  });

  var watching = false, repaintTimer = null;
  function watchUpcart() {
    if (watching) return;
    var root = upcartRoot();
    if (!root || typeof MutationObserver === 'undefined') return;
    watching = true;
    new MutationObserver(function () {
      clearTimeout(repaintTimer);
      repaintTimer = setTimeout(function () { if (lastLines) paint(lastLines); }, 80);
    }).observe(root, { childList: true, subtree: true });
  }
  var watchTries = 0;
  var watchPoll = setInterval(function () {
    watchUpcart();
    if (watching || ++watchTries > 40) clearInterval(watchPoll);
  }, 500);
  var of = window.fetch;
  window.fetch = function () {
    var u = arguments[0] && (arguments[0].url || arguments[0]);
    var p = of.apply(this, arguments);
    if (typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u)) p.then(function () { setTimeout(refresh, 120); });
    return p;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
  window.MNCartNudge = { refresh: refresh, _calc: discountFor, _messages: messages, _cfg: CFG };
})();
